import React from 'react';
const Footer = () => {
  return (
    <footer className="bg-[#000000] border-t border-white/5 text-white py-12 relative z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">

          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="flex items-center justify-center w-12 h-12 bg-white/10 backdrop-blur-md rounded-full shadow-lg border border-white/10">
                <img
                  src="/images/logo.png"
                  alt="MarryCenter Logo"
                  className="w-8 h-8 rounded-full object-cover"
                />
              </div>
              <span className="text-2xl font-bold bg-gradient-to-r from-pink-400 to-rose-400 bg-clip-text text-transparent" style={{ fontFamily: 'Helvetica, Arial, sans-serif' }}>MarryCenter</span>
            </div>
            <p className="text-white mb-4 max-w-md">
              Helping millions of people find their perfect life partner through intelligent matching and verified profiles.
            </p>
            <div className="flex space-x-4">
              {['Facebook', 'Twitter', 'Instagram', 'LinkedIn'].map((social) => (
                <button key={social} className="text-white hover:text-pink-400 transition-colors duration-200">
                  {social}
                </button>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2 text-white">
              {['About Us', 'Success Stories', 'Pricing', 'Contact Us', 'Blog'].map((link) => (
                <li key={link}>
                  <button type="button" className="hover:text-pink-400 transition-colors duration-200">
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Legal</h3>
            <ul className="space-y-2 text-white">
              <li>
                <a href="https://marrycenter.com/app/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-pink-400 transition-colors duration-200">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="https://marrycenter.com/app/terms" target="_blank" rel="noopener noreferrer" className="hover:text-pink-400 transition-colors duration-200">
                  Terms of Service
                </a>
              </li>
              {['Safety Tips', 'Community Guidelines'].map((link) => (
                <li key={link}>
                  <button type="button" className="hover:text-pink-400 transition-colors duration-200">
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 mt-8 pt-8 text-center text-slate-500">
          <p>&copy; 2025 MarryCenter Matrimonial Services. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;